import React from "react";
import { makeStyles } from "tss-react/mui";
import logoFooter from "../../../assets/img/logos/logo.svg";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import config from "../../../utils/config";
import FooterLink from "./footerLink";

// Import Social logos
import facebook from "../../../assets/img/socialLogos/facebookSocialLogo.svg";
import twitter from "../../../assets/img/socialLogos/twitterSocialLogo.svg";
import youtube from "../../../assets/img/socialLogos/youtubeSocialLogo.svg";
import pinterest from "../../../assets/img/socialLogos/pinterestSocialLogo.svg";

// Redux stuff
import { connect } from "react-redux";

const useStyles = makeStyles()((theme) => ({
  button: {
    color: "white",
  },
  fullDiv: {
    display: "flex",
    backgroundColor: theme.palette.darkGrey.main,
  },
  columnsDiv: {
    minHeight: 550,
    margin: "auto",
    padding: 40,

    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignContent: "center",

    [theme.breakpoints.down("md")]: {
      padding: 20,
    },
  },
  column: {
    padding: 20,
    display: "inline-flex",
    flexDirection: "column",
  },
  socialsDiv: {
    display: "flex",
    padding: "10px 0px 10px 0px",
  },
  socialButton: {
    paddingRight: 10,
    paddingTop: theme.spacing(1),
  },
  smallPrint: {
    color: "black",
    paddingLeft: 5,
    paddingBottom: 10,
    textDecoration: "none",
  },
  footerTitle: {
    fontSize: 22,
    paddingBottom: 10,
    fontWeight: "bold",
  },
  footerSecondRowHeader: {
    paddingTop: 50,
  },
  logoDiv: {
    display: "flex",
    justifyContent: "left",
  },
  logoFooter: {
    maxHeight: 45,
  },
}));

function Footer(props) {
  const { classes } = useStyles();

  function socialIcon(href, src, alt) {
    return (
      <a href={href} target="_blank" className={classes.socialButton}>
        <img src={src} alt={alt} />
      </a>
    );
  }

  return (
    <div className={classes.fullDiv}>
      <div className={classes.columnsDiv}>
        <div className={classes.column}>
          <div className={classes.logoDiv}>
            <img
              src={logoFooter}
              alt="post-generator-logo"
              className={classes.logoFooter}
            />
          </div>
          <div className={classes.socialsDiv}>
            {socialIcon(
              "https://www.youtube.com/@oliverboyers?sub_confirmation=1",
              youtube,
              "youtube-logo"
            )}
            {socialIcon(
              "https://twitter.com/OliverBoyers",
              twitter,
              "twitter-logo"
            )}
            {/* {socialIcon(
              "https://www.facebook.com/contentgeneratorofficial",
              facebook,
              "facebook-logo"
            )} */}
          </div>
          <Typography
            component={Link}
            to={"/privacy-policy"}
            className={classes.smallPrint}
          >
            Privacy Policy
          </Typography>
          <Typography
            component={Link}
            to={"/terms-and-conditions"}
            target="_blank"
            className={classes.smallPrint}
          >
            Terms and Conditions
          </Typography>
          <Typography className={classes.smallPrint}>
            © {new Date().getFullYear()} Content Generator
          </Typography>
          <Typography className={classes.smallPrint}>
            PT Brimbrook House Technology
          </Typography>
        </div>
        <div className={classes.column}>
          <Typography className={classes.footerTitle}>
            How to use Content Generator
          </Typography>
          <FooterLink
            href="#"
            text="Beginners guide to Content Generator"
            isExternalLink={true}
          />
          <FooterLink
            href="/savings-calculator"
            text="Savings calculator"
            isExternalLink={false}
          />
        </div>
        <div className={classes.column}>
          <Typography className={`${classes.footerTitle}`}>
            Product features
          </Typography>
          <FooterLink
            href="/generate"
            text="Generate Social Media posts"
            isExternalLink={false}
          />
          <FooterLink
            href="/scheduling"
            text="Schedule Social Media posts"
            isExternalLink={false}
          />
          <FooterLink
            href="/templates"
            text="Create your own social media templates"
            isExternalLink={false}
          />
          <FooterLink
            href="/affiliate"
            text="Affiliate program"
            isExternalLink={false}
          />
        </div>
        <div className={classes.column}>
          <Typography className={`${classes.footerTitle}`}>
            Content marketing tutorials
          </Typography>
          <FooterLink
            href="https://youtu.be/XzI0gGKrwUI"
            text="Full tutorial on how to use Content Generator."
            isExternalLink={true}
          />
          <FooterLink
            href="https://youtu.be/Lbi0PKd4NMk"
            text="Quick tutorial on how to use Content Generator."
            isExternalLink={true}
          />
          <FooterLink
            href="https://youtu.be/HpEvuni73JA"
            text="How to automate content creation with AI."
            isExternalLink={true}
          />
        </div>
        <div className={classes.column}>
          <Typography className={`${classes.footerTitle}`}>Other</Typography>
          <FooterLink href="/blog" text="Blog" isExternalLink={false} />
          <FooterLink href="/pricing" text="Pricing" isExternalLink={false} />
          <FooterLink
            href="https://contentgenerator.tawk.help/"
            text="FAQs"
            isExternalLink={true}
          />
          <FooterLink href="/contact" text="Contact" isExternalLink={false} />
          <FooterLink
            href="https://contentgenerator.tawk.help/"
            text="Support"
            isExternalLink={true}
          />
          <FooterLink
            href="/founding-partners"
            text="Founding Partners"
            isExternalLink={false}
          />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(Footer);
